/* eslint react-hooks/exhaustive-deps: "error" */
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import GET_CURRENT_AND_NEXT_LIVES from 'Jsx/CrehanaLive/graphql/GetCurrentAndNextLives.graphql';
import { GetCurrentAndNextLives } from 'Jsx/CrehanaLive/graphql/types/GetCurrentAndNextLives';

import GET_CURRENT_AND_NEXT_LIVES_B2B from 'Jsx/CrehanaLive/graphql/GetCurrentAndNextLivesB2B.graphql';
import {
  GetCurrentAndNextLivesB2B,
  GetCurrentAndNextLivesB2BVariables,
} from 'Jsx/CrehanaLive/graphql/types/GetCurrentAndNextLivesB2B';

import { LiveNode } from 'Jsx/CrehanaLive/graphql/types/LiveNode';

type UseCurrentAndNextLivesOptions = {
  isB2B: boolean;
  variables?: GetCurrentAndNextLivesB2BVariables;
};

function useCurrentAndNextLives(options?: UseCurrentAndNextLivesOptions) {
  const isB2B = !!options?.isB2B;
  const response = useQuery<GetCurrentAndNextLives>(
    GET_CURRENT_AND_NEXT_LIVES,
    { skip: isB2B },
  );
  const b2bResponse = useQuery<
    GetCurrentAndNextLivesB2B,
    GetCurrentAndNextLivesB2BVariables
  >(GET_CURRENT_AND_NEXT_LIVES_B2B, {
    variables: options?.variables,
    skip: !isB2B,
  });

  const { data, loading, error, refetch, updateQuery } = isB2B
    ? b2bResponse
    : response;

  const showRefetch = !!(error || !data);

  const featuredLive: LiveNode | null | undefined = useMemo(() => {
    if (data?.currentLive?.edges.length) {
      return data.currentLive.edges[0]?.node;
    }

    return data?.nextLives?.edges[0]?.node;
  }, [data]);

  const nextLives: LiveNode[] = useMemo(() => {
    const areWeLive =
      data?.currentLive?.edges && data.currentLive.edges.length > 0;

    const next = data?.nextLives?.edges.map(e => e!.node!) || [];

    return areWeLive ? next : next.slice(1, next.length);
  }, [data]);

  return {
    featuredLive,
    nextLives,
    showRefetch,
    loading,
    error,
    refetch,
    updateQuery,
  };
}

export default useCurrentAndNextLives;
